<form class="flex flex-1 flex-col m-8" [formGroup]="roleForm">
  <div class="flex flex-1 space-x-4">
    <div class="flex flex-auto flex-1 w-64 flex-col">
      <span class="form-field-header">Role name*</span>
      <lib-common-ui-components-text-input
        floatLabel="always"
        [hideRequiredMarker]="true"
        [required]="true"
        formControlName="name"
        placeholder="Enter a name"
        fontSize="16px"
      ></lib-common-ui-components-text-input>
      <span class="form-field-header">Role description*</span>
      <lib-common-ui-components-text-input
        floatLabel="always"
        [hideRequiredMarker]="true"
        [required]="true"
        formControlName="description"
        [textArea]="true"
        placeholder="Enter a description"
        fontSize="16px"
      ></lib-common-ui-components-text-input>
    </div>
    <div class="flex flex-auto w-32 mt-[25px]">
      <lib-cdw-message-band
        mode="info-white"
        [textColor]="grey300Color"
        fontWeight="500"
        fontFamily="Roboto, sans-serif"
        fontSize="16px"
        >Users can only perform actions, create jobs, and be given view permissions on assets within the designated
        OUs.</lib-cdw-message-band
      >
    </div>
  </div>
  <div *ngFor="let permission of permissions">
    <div *ngIf="!permission.parentId && permission.children?.length">
      <mat-slide-toggle
        class="py-3"
        [formControlName]="'slide-toggle-' + permission.name"
        (change)="onSlideToggleChange(permission)"
        color="primary"
        ><span class="flex permission-header">{{ permission.name }}</span></mat-slide-toggle
      >
    </div>
    <div
      *ngIf="
        !permission.parentId && permission.children?.length && roleForm.get('slide-toggle-' + permission.name)?.value
      "
      class="permissions-box flex flex-row space-x-4"
    >
      <div class="flex flex-auto flex-1 w-64 flex-col">
        <div *ngFor="let children of permission.children">
          <ng-container *ngTemplateOutlet="tree; context: { permission: children, isRoot: true }"> </ng-container>
        </div>
      </div>
      <div class="flex flex-auto w-32 items-center">
        <lib-cdw-message-band [fullWidth]="true" mode="info" fontWeight="400" fontFamily="Roboto, sans-serif" fontSize="16px"
          >Please note<br />• &nbsp;&nbsp; Viewing is automatically enabled on permitted actions</lib-cdw-message-band
        >
      </div>
    </div>
    <lib-cdw-divider color="#D9DFEA" *ngIf="!roleForm.get('slide-toggle-' + permission.name)?.value"></lib-cdw-divider>
    <div *ngIf="!permission.parentId && !permission.children?.length">
      <lib-cdw-checkbox [formControlName]="permission.id.toString()">{{ permission.name }}</lib-cdw-checkbox>
      <lib-cdw-divider color="#D9DFEA"></lib-cdw-divider>
    </div>
  </div>

  <div class="flex flex-row flex-auto space-x-4 mt-8">
    <lib-cdw-button
      *ngIf="role"
      class="flex flex-1"
      (buttonClick)="onDeleteRole()"
      level="warn"
      fontFamily="Roboto, sans-serif"
      >Delete role</lib-cdw-button
    >
    <lib-cdw-button
      class="ml-auto"
      (buttonClick)="onCancelRole()"
      level="secondary"
      fontFamily="Roboto, sans-serif"
      [fontColor]="grey400Color"
      fontWeight="700"
      >Cancel</lib-cdw-button
    >
    <lib-cdw-button
      (buttonClick)="onSaveRole()"
      [disabled]="!roleForm.valid"
      level="primary"
      fontFamily="Roboto, sans-serif"
      fontWeight="700"
      >Save role</lib-cdw-button
    >
  </div>
</form>

<ng-template #tree let-permission="permission" let-isRoot="isRoot">
  <div
    class="mx-6 mb-6"
    [ngClass]="{ 'px-11': !isRoot }"
    *ngIf="permission.children && permission.children?.length > 0"
  >
    <span class="permission-sub-header">{{ permission.name }}</span>
    <lib-cdw-divider color="#D9DFEA" class="block w-[45%] pb-2"></lib-cdw-divider>
    <ng-container *ngFor="let child of permission.children">
      <ng-container *ngTemplateOutlet="tree; context: { permission: child, isRoot: false }"> </ng-container>
    </ng-container>
  </div>
  <div class="py-1" *ngIf="!permission.children || permission.children?.length === 0" [formGroup]="roleForm">
    <lib-cdw-checkbox class="flex text-[1px] h-6 leading-8" [formControlName]="permission.id.toString()"
      ><span class="text-[16px] leading-8">{{ permission.name }}</span></lib-cdw-checkbox
    >
  </div>
</ng-template>
